import Preloader from "@/components/loading/Preloader"

export default function Loading() {
    // Wrapper in normal flow : Next skips `position: fixed` elements when applying the scroll to top after a navigation
    return (
        <div>
            <Preloader />
        </div>
    )
}
